<template>
  <div class="loginContainer">
    <LoginHeader></LoginHeader>
    <div class="login-content outer-container">
      <form class="form-signin inner-container" @submit.prevent="resetPassword(email)" id="form">
        <div class="wellmetrics-event-pl">WELLMETRICS EVENT PLANNER</div>
        <br/>
        <div class="subText">Create, request and schedule biometric screening events with ADURO</div>
        <div class="formInput">
          <div>
            <div class="form-title" v-if="!getIsResetPassword">
              Enter your email to reset your password.
            </div>
            <div class="form-title" v-if="getIsResetPassword">
              A reset password has been requested. Check your email.
            </div>

            <div class="row inputText">
              <div class="labelText">
                <label>Email address</label>
              </div>
              <div class="input-wrapper">
                <label v-if="!getIsResetPassword">
                  <input type="email" v-model="email" class="form-control" required autofocus>
                </label>
                <label class="success-reset-password" v-if="getIsResetPassword">
                  {{email}}
                </label>
              </div>
            </div>
            <div class="row footerForm">
              <div class="col-md-9 forgotPassword">
                <router-link to="/login" v-if="!getIsResetPassword">
                  <a href="#">Back to Login</a>
                </router-link>
              </div>
              <div class="col-md-3">
                <button v-if="!getIsResetPassword" class="btn btn-reset-password" type="submit" :disabled="getIsSubmitted">Reset password</button>
                <button v-if="getIsResetPassword" class="btn btn-reset-password" @click="backToLoginPage()">Done</button>
              </div>
            </div>
          </div>
          <div class="row text-center alert-danger" v-if="getIsError">
            <div class="col-md-12">
              {{ getErrorMessage }}
            </div>
          </div>
        </div>

      </form>
    </div>
  </div> <!-- /container -->
</template>

<script>
  import LoginHeader from './login/LoginHeader';
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'resetPassword',
    components: {
      LoginHeader
    },
    data () {
      return {
        email: null,
        submitData: null
      };
    },
    computed: {
      ...mapGetters({
        getIsError: 'GETTERS_IS_ERROR',
        getErrorMessage: 'GETTERS_ERROR_MESSAGE',
        getIsResetPassword: 'GETTERS_IS_RESET_PASSWORD_SUCCESS',
        getIsSubmitted: 'GETTERS_IS_SUBMITTED'
      })
    },
    methods: {
      resetPassword: function () {
        this.doResetPassword(this.email);
      },
      backToLoginPage () {
        this.$router.push('/login');
        this.setIsRequestPasswordSuccess(false);
      },
      ...mapActions({
        setIsRequestPasswordSuccess: 'ACTION_SET_RESET_PASSWORD',
        doResetPassword: 'ACTION_RESET_PASSWORD'
      })
    }
  };
</script>

<style lang="less" scoped>
  @import '../../styles/variables.less';

  .loginContainer {
    height: 100vh;
    background-color: @blue;

    .login-content {
      position: absolute;
      top: 25%;
    }
    .wellmetrics-event-pl {
      height: 29px;
      color: @white;
      font-family: @font-family-title;
      font-size: 27px;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .labelText {
      margin-top: 10px;
      width: 30%;
    }
    .subText {
      font-family: @font-family-title;
      font-size: 14px;
      color: @white;
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }

    .formInput {
      background-color: @white;
      height: 255px;
      width: 575px;
      border-radius: 5px;
      padding: 55px 50px 35px 50px;
      margin: auto;
      .form-title {
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: bold;
        padding: 0;
      }
    }

    .inputText {
      margin: 25px 0 0 0;
      .input-wrapper {
        width: 70%;
        label {
          width: 100%;
        }
      }
    }

    .submitButton {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
    }

    .btn-reset-password {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
      padding: 7px 25px 10px 25px;
    }

    .forgotPassword {
      margin-top: 20px;
    }

    .loginContainer {
      height: 100%;
    }

    .form-signin {
      padding: 15px;
      margin: 0 auto;
    }

    .footerForm {
      margin-top: 25px;
    }

    .form-signin .form-signin-heading,
    .form-signin .checkbox {
      margin-bottom: 10px;
      text-align: center;
      margin-top: 20px;
    }
    .form-signin .checkbox {
      font-weight: normal;
    }
    .form-signin .form-control {
      position: relative;
      height: auto;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 16px;
      border-radius: 5px;
      background-color: @white;
    }
    .form-signin .form-control:focus {
      z-index: 2;
    }

    .success-reset-password {
      padding-top: 10px;
    }

  }
</style>




// WEBPACK FOOTER //
// ResetPassword.vue?02842e6a